#import "../WorkgroupGroupFields.graphql"
query WorkgroupGroups($first: Int!, $orderBy: [WorkgroupGroupsOrderBy!]) {
  workgroupGroups(first: $first, orderBy: $orderBy) {
    nodes {
      ...WorkgroupGroupFields
    }
  }
}
